module.exports = __webpack_public_path__ + "static/media/banner.82bf264e.png";